import React from 'react';
import styles from './index.module.scss';

const RemainingLimit = ({ className }) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='48'
        height='48'
        viewBox='0 0 48 48'
        className={className}
    >
        <circle cx='24' cy='24' r='24' transform='translate(0 0)' className={styles.light} />
        <path
            d='M226.989,435.182v-7.148a8.082,8.082,0,0,0-6.049-7.636l-.6-.166v10.225l-3.57.87V420.233l-.6.166a8.082,8.082,0,0,0-6.049,7.636v7.148H206.56v-7.148a11.522,11.522,0,0,1,9.834-11.147l.381-.066v-2.37l3.57-.87v3.239l.381.066a11.522,11.522,0,0,1,9.834,11.147v7.148Z'
            transform='translate(-194.56 -401.582)'
            className={styles.dark}
        />
    </svg>
);

export default RemainingLimit;
